// extracted by mini-css-extract-plugin
export default {"pageWrap":"wd-z","fullWidth":"xd-z","heading":"yd-z","fullBleed":"zd-z","hidden":"Ad-z"};